import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import './ContactUs.css'
import { Link } from 'react-router-dom'
const ContactUs = () => {
  return (
    <>
    
    <div style={{ background: "rgb(42, 157, 244)", color: "#fff", padding: "60px" }} className="exploreUkMain">
        <Container>
          <Row>
            <Col xs={12}>
              <h2
                style={{
                  fontSize: "30px",
                  textTransform: "capitalize",
                  color: "#fff",
                  marginBottom: "17px",
                  fontWeight: "800",
                  textAlign: "center",
                }}
              >
                Explore the{" "}
                <strong style={{ color: "white" }}>
                  UK with Experienced Drivers.
                </strong>
              </h2>
              <Link to="/customer/contactUs">   <div
                style={{
                  background: "#fff",
                  color: "#000",
                  padding: "15px 25px",
                  fontSize: "18px",
                  display: "block",
                  width: "245px",
                  margin: "35px auto 0",
                  textAlign: "center",
                  fontWeight: "700",
                  borderRadius:"10px"
                }}
              >
                Contact Us
              </div></Link>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )

}

export default ContactUs